module.exports = __webpack_public_path__ + "static/3drender-805050f9c84223695dd68fe2cce9b398.png";